
import React from 'react';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { LocationPoint } from './utils/locationHistoryUtils';

interface LocationHistoryTableProps {
  locationHistory: LocationPoint[];
  showMileage?: boolean;
}

const LocationHistoryTable: React.FC<LocationHistoryTableProps> = ({ 
  locationHistory, 
  showMileage = false 
}) => {
  const formatMileage = (mileage?: number): string => {
    if (!mileage || mileage === 0) return '--';
    return `${mileage.toFixed(3)} км`;
  };

  const formatTimestamp = (timestamp: string | Date): string => {
    const date = typeof timestamp === 'string' ? new Date(timestamp) : timestamp;
    return format(date, 'dd.MM.yyyy HH:mm:ss', { locale: ru });
  };

  return (
    <div className="mt-4 overflow-y-auto max-h-[300px]">
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b">
            <th className="py-2 text-left font-medium">Дата и время</th>
            <th className="py-2 text-left font-medium">Скорость</th>
            {showMileage && <th className="py-2 text-left font-medium">Участок</th>}
            <th className="py-2 text-left font-medium">Заряд</th>
            <th className="py-2 text-left font-medium">Координаты</th>
          </tr>
        </thead>
        <tbody>
          {locationHistory.length > 0 ? (
            locationHistory.map((point) => (
              <tr key={point.id} className="border-b hover:bg-muted/50">
                <td className="py-2">
                  {formatTimestamp(point.timestamp)}
                </td>
                <td className="py-2">{point.speed || 0} км/ч</td>
                {showMileage && (
                  <td className="py-2 text-tuktuk-teal font-medium">
                    {formatMileage(point.rental_mileage)}
                  </td>
                )}
                <td className="py-2">{point.battery_level || '--'}%</td>
                <td className="py-2 text-xs">
                  {point.latitude.toFixed(6)}, {point.longitude.toFixed(6)}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={showMileage ? 5 : 4} className="py-4 text-center text-muted-foreground">
                История перемещений не найдена
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default LocationHistoryTable;
